import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Badge
} from "reactstrap";
import {
  Link
} from "react-router-dom";

import ReactTable from "react-table";
import {getProvisionerServiceItem} from '../../settings/shared/commonMethod'
import ProvisionerService from '../../services/api/Provisioner'; 
import PlatformProvisionerService from '../../services/api/PlatformProvisioner';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment'
import { toast } from 'react-toastify';
import { Scrollbars } from 'react-custom-scrollbars';

// import { toast } from '../../settings/shared/constants';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { provisionerTypeLogo } from "settings/shared/commonMethod";
import Pagination from "../../assets/js/Pagination";


class Provisioner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns:[],
      provisionerDTOS:[],
      provisionerdetails:[],
    swidth: window.innerWidth,
    sheight: window.innerHeight
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state.columns = [
      {
      Header: 'Id',
      accessor: 'Id',
      sortable: true,
      show: false
    }, 
    {
    Header: 'Provisioner Name',
    accessor: 'Name',
    maxWidth: 200,
    sortable: true,
     }, 
    {
    Header: 'Description',
    accessor: 'Description',
    maxWidth: 200,

  },
  {
    Header: 'Services',
    accessor: 'Services',
    maxWidth: 200,
  },
  {
    Header: 'Provisioner Type',
    accessor: 'provisionerType',
    maxWidth: 200,
  },
  {
      Header: 'Created By',
      accessor: 'Created',
      maxWidth: 100,
    }, {
      Header: 'Last Modified',
      accessor: 'Lastmodified',
      maxWidth: 150,
    },
  {
    Header: 'Actions',
    accessor: 'Actions',
    maxWidth: 135,

  }

];
  }
  componentDidMount() {
    this.GetAllProvisioner();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  EditProvisioner = (data) =>{
    this.props.history.push({
      pathname: '/cloud/NewProvisioner',
      state: { editId: data.id, type : data.provisionerType, mode:"editProvisioner" }
    })
  }


  DeleteProvisionerConfirm = (id,name) =>{
    confirmAlert({
      title: 'Remove Provisioner',
      message: 'Are you sure to remove this provisioner -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeleteProvisioner(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  // Delete Connector
  DeleteProvisioner = (id) => {
    if (id !== "") {
      ProvisionerService.deleteProvisioner(id).then((response) => {
        if (response.status === 'SUCCESS') {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Provisioner Deleted Successfully!</b></i>);
          this.GetAllProvisioner();
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });

    }
}

GetAllProvisioner = () =>{
  this.setState({
    loading:true
  })

  ProvisionerService.getAllProvisioner()
  .then((response) => {
    if (response.status === 'SUCCESS') {
      let provisionerData = response.provisionerDTOPage.content;
      this.renderData(provisionerData);  
      this.setState({
        provisionerDTOS:provisionerData,
        loading: false,
      });
      } else {
      this.setState({ loading: false}); 
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
  }).catch((error) => {
    this.setState({ loading:false });
  })
}

 renderData(provisionerdetails){
  let datas = []; 
  let role = localStorage.getItem('role')
  provisionerdetails.map((item, index) => {
    let _services = []
    for (let service of item.services) {
      let serviceItem = getProvisionerServiceItem(service)
      _services.push(<Badge className={serviceItem.badge + " mr-1"}>{serviceItem.label}</Badge>)
    }
    let itemData = {
      Id: item.id, 
      Name: <div className="namedisplay"> <span title={item.name} className="overflowStyle">{item.name}</span></div>,
      Description:<div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
      Services: <div className="row namedisplay">{_services}</div>,
      provisionerType:<div className="ml-3"> {<img src={provisionerTypeLogo(item.provisionerType)} alt="logo" />
     }</div>,
      Created:<div className="namedisplay"> {item.createdBy}</div>,
      Lastmodified:<div>{item.updatedDate != null ?moment.utc(item.updatedDate).local().format('MMM DD, YYYY') : ""} <br></br>{item.updatedDate != null ? moment.utc(item.updatedDate).local().format('hh:mm A') : ""}</div>,
      Actions: ((role !== null && role !== undefined && role === 'PLATFORM_ADMIN') || item.platformDefault !== true) && <div>
        <i style={{cursor:"pointer"}} onClick={e=>this.EditProvisioner(item)} className="fa fa-edit text-info"/>
        <i style={{cursor:"pointer", marginLeft:10,color:"red"}} onClick={e=>this.DeleteProvisionerConfirm(item.id,item.name)} className="fas fa-trash-alt text-red mr-2"/>
        </div>
      }
   datas.push(itemData)
  });

   this.setState({
      provisionerdetails:datas,
   });

}
 

  
  render() {
    return (
  
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
            <Row>
            <div className=" col">
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Provisioners</CardTitle>
                 </div>
                 <div className="col text-right">
                 {/* <Link to={{
                        pathname: '/integration/connectors'
                      }}>  */}
                      <span> <i style={{cursor:"pointer"}} className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllProvisioner()}/></span>
                       {/* </Link> */}
                       <Link to={{ 
                        pathname: '/cloud/NewProvisioner',
                        state: { mode:"addnew" }
                      }}> 
                         <Button
                        color="primary"
                        href=""
                        size="sm"
                      >
                      Create Provisioner
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                <CardBody >
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <ReactTable
         data={ this.state.provisionerdetails}
         columns={ this.state.columns }
         defaultPageSize={10}
         PaginationComponent={Pagination}
         showPaginationBottom={true}
         className="-striped -highlight Providerstable"
          />
                       </Scrollbars>

          </div>
              </CardBody>
              </Card>
           </div>
           </Row>

            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default Provisioner;

